import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'itemlist',

  data() {
    return {
      itemSearchWord: '',

      sortKey: 'alert',
      sortOrder: {
        item_id: 'asc',
        price: 'asc',
        sales_start_date: 'asc',
        consumption: 'asc',
        alert: 'desc'
      }
    }
  },

  computed: {
    ...mapGetters('category', ['predictSelectedCategoryId']),
    ...mapGetters('predict', ['suggestState']),

    ...mapGetters('itemlist', [
      'itemlist',
      'selectedItemId',
      'markdownGather',
      'orderGather',
      'orderGatherSku'
    ]),

    /**
     * item一覧
     * 検索単語のフィルタとソートを行う
     */
    items() {
      return _.orderBy(
        _.filter(
          this.itemlist,
          item => {
            return (
              _.includes(item.item_id, this.itemSearchWord) ||
              _.includes(item.item_name, this.itemSearchWord) ||
              _.includes(item.sales_start_date, this.itemSearchWord) ||
              _.includes(item.consumption.toString(), this.itemSearchWord) ||
              _.includes(item.price.toString(), this.itemSearchWord)
            )
          }
        ),
        item => item[this.sortKey],
        this.sortOrder[this.sortKey]
      )
    },

    cssSearchWordEmpty() {
      return this.itemSearchWord.length === 0 ? 'nodisplay' : ''
    }
  },

  methods: {
    ...mapActions('detail', ['getDetailItem']),
    ...mapActions('predict', ['getPredictItem']),
    ...mapActions('skulist', ['getSkulist']),

    ...mapActions('itemlist', [
      'setSelectedItemId',
      'getMarkdownGatherItemlist',
      'getOrderGatherItemlist',
      'getOrderGatherSkulist',
      'getPredictLogDownload',
      'getSaleMarkDownCSVDownload',
      'getWeeklyMarkDownCSVDownload'
    ]),

    /**
     * ソート変更時
     */
    changeItemSortOption(key) {
      if (this.sortKey == key) {
        this.sortOrder[key] = this.sortOrder[key] === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
      }
    },

    /**
     * item選択時
     * item単位でそれぞれ取得して表示
     */
    selectItem(itemId) {
      if (!this.suggestState) return

      this.setSelectedItemId(itemId)
      this.getSkulist({ itemId: itemId })
      this.getDetailItem({ itemId: itemId })
      this.getPredictItem({ itemId: itemId })
    },

    // 動的css。ヘッダ
    cssItemListHeader(key) {
      return {
        'sort-active': this.sortKey === key,
        'sort-isAsc': this.sortOrder[key] === 'asc'
      }
    },

    // 動的css。item一覧の選択行
    selectRow(itemId) {
      return this.selectedItemId === itemId ? 'item-list__row--selected' : ''
    },

    // 動的css。alertが発生してれば色変更
    cssAlert(count) {
      return count === 0 ? '' : 'item-list__alert'
    },

    /**
     * ページ遷移した場合、選択しているitemまでスクロール
     */
    scrollItem_() {
      if (this.items.length === 0) return
      const body = document.querySelector('.item-list__body')
      const idx = _.findIndex(this.items, { item_id: this.selectedItemId })
      if (idx === -1) return
      body.scrollTop = body.childNodes[idx].offsetTop - 46
    },

    changeFocusByUpKey(filterItems, currentIndex) {
      if (currentIndex === 0) return
      document.getElementById(`item-${currentIndex - 1}`).focus()
    },

    changeFocusByDownKey(filterItems, currentIndex) {
      if (currentIndex === filterItems.length - 1) return
      document.getElementById(`item-${currentIndex + 1}`).focus()
    },

    /**
     * マークダウンCSVダウンロード
     * item一覧のマークダウン情報を付与したCSVファイルをダウンロードする
     */
    async onMarkDownload() {
      const itemlist = []
      _.forEach(this.items, item => {
        itemlist.push(item.item_id)
      })

      await this.getMarkdownGatherItemlist({ itemlist: itemlist })

      let content = this.markCsvTitle_()
      const itemdict = this.markdownGather.itemdict
      _.forEach(this.items, item => {
        if (_.has(itemdict, item.item_id)) {
          content += this.markToCsv_(item, itemdict[item.item_id])
        }
      })

      const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      const blob = new Blob([bom, content], { "type": "text/plain" })
      this.downloadCsv_('mark_itemlist.csv', blob)
    },

    /**
     * マークダウンCSVタイトル
     */
    markCsvTitle_() {
      const tWeek = '[対象週]'
      const lWeek = '[最終週]'
      const predictCol = ['予測販売数', '予測売上金額', '予測粗利益', '予測残在庫数', '予測消化率']
      const suggestCol = ['AIサジェスト値引率', 'AIサジェスト後予測販売数', 'AIサジェスト後売上金額', 'AIサジェスト後粗利益', 'AIサジェスト後予測残在庫数', 'AIサジェスト後予測消化率']
      const resultCol = ['売上差額', '粗利差額']
      const groups = [tWeek, lWeek]
      let title = 'アイテムカテゴリ,品番,商品名,定価,販売開始日,アラート,当在庫,'

      _.forEach(groups, group => {
        _.forEach(predictCol, col => title += `${group}${col},`)
        _.forEach(suggestCol, col => title += `${group}${col},`)
        _.forEach(resultCol, col => title += `${group}${col},`)
      })
      _.forEach(suggestCol, col => title += `[当週]${col},`)

      return title.slice(0, -1) + '\n'
    },

    /**
     * item一覧をマークダウンCSVに変換
     */
    markToCsv_(item, data) {
      const list = [
        data.category_name,
        item.item_id,
        item.item_name,
        item.price,
        item.sales_start_date,
        item.alert,
        data.actual_stock,
        data.target_sale,
        data.target_amount,
        data.target_profit,
        data.target_stock,
        data.target_consumption,
        data.target_mark_offrate,
        data.target_mark_sale,
        data.target_mark_amount,
        data.target_mark_profit,
        data.target_mark_stock,
        data.target_mark_consumption,
        data.target_amount_diff,
        data.target_profit_diff,
        data.last_sale,
        data.last_amount,
        data.last_profit,
        data.last_stock,
        data.last_consumption,
        data.last_mark_offrate,
        data.last_mark_sale,
        data.last_mark_amount,
        data.last_mark_profit,
        data.last_mark_stock,
        data.last_mark_consumption,
        data.last_amount_diff,
        data.last_profit_diff,
        data.this_mark_offrate,
        data.this_mark_sale,
        data.this_mark_amount,
        data.this_mark_profit,
        data.this_mark_stock,
        data.this_mark_consumption
      ]
      return list.join(',') + '\n'
    },

    /**
     * 追加発注CSV(品番)ダウンロード
     * item一覧の追加発注情報を付与したCSVファイルをダウンロードする
     */
    async onItemOrderDownload() {
      const itemlist = []
      _.forEach(this.items, item => {
        itemlist.push(item.item_id)
      })

      await this.getOrderGatherItemlist({ itemlist: itemlist })

      let content = this.orderCsvTitle_()
      const itemdict = this.orderGather.itemdict
      _.forEach(this.items, item => {
        if (_.has(itemdict, item.item_id)) {
          content += this.orderToCsv_(item, itemdict[item.item_id])
        }
      })

      const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      const blob = new Blob([bom, content], { "type": "text/plain" })
      this.downloadCsv_('order_itemlist.csv', blob)
    },

    /**
     * 追加発注CSV(品番)タイトル
     */
    orderCsvTitle_() {
      const tWeek = '[対象週]'
      const lWeek = '[最終週]'
      const predictCol = ['予測販売数', '予測売上金額', '予測粗利益', '予測残在庫数', '予測消化率']
      const suggestCol = ['AIサジェスト後予測販売数', 'AIサジェスト後売上金額', 'AIサジェスト後粗利益', 'AIサジェスト後予測残在庫数', 'AIサジェスト後予測消化率']
      const resultCol = ['売上差額', '粗利差額']
      let title = 'アイテムカテゴリ,品番,商品名,定価,販売開始日,アラート,当在庫,'

      _.forEach(predictCol, col => title += `${tWeek}${col},`)
      title += '投入週,投入数,'
      _.forEach(predictCol, col => title += `${lWeek}${col},`)
      _.forEach(suggestCol, col => title += `${lWeek}${col},`)
      _.forEach(resultCol, col => title += `${lWeek}${col},`)

      return title.slice(0, -1) + '\n'
    },

    /**
     * item情報を追加発注CSV(品番)に変換
     */
    orderToCsv_(item, data) {
      const list = [
        data.category_name,
        item.item_id,
        item.item_name,
        item.price,
        item.sales_start_date,
        item.alert,
        data.actual_stock,
        data.target_sale,
        data.target_amount,
        data.target_profit,
        data.target_stock,
        data.target_consumption,
        data.order_feed_week,
        data.order_num,
        data.last_sale,
        data.last_amount,
        data.last_profit,
        data.last_stock,
        data.last_consumption,
        data.order_sale,
        data.order_amount,
        data.order_profit,
        data.order_stock,
        data.order_consumption,
        data.last_amount_diff,
        data.last_profit_diff
      ]
      return list.join(',') + '\n'
    },

    /**
     * 追加発注CSV(SKU)ダウンロード
     * item一覧の追加発注情報を付与したCSVファイルをダウンロードする
     */
    async onSkuOrderDownload() {
      const itemlist = []
      _.forEach(this.items, item => {
        itemlist.push(item.item_id)
      })

      await this.getOrderGatherSkulist({ itemlist: itemlist })

      let content = this.orderSkuCsvTitle_()
      const skulist = this.orderGatherSku
      _.forEach(skulist, sku => {
        content += this.orderSkuToCsv_(sku)
      })

      const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      const blob = new Blob([bom, content], { "type": "text/plain" })
      this.downloadCsv_('order_skulist.csv', blob)
    },

    /**
     * 追加発注CSV(SKU)タイトル
     */
    orderSkuCsvTitle_() {
      const tWeek = '[対象週]'
      const lWeek = '[最終週]'
      const predictCol = ['予測販売数', '予測売上金額', '予測粗利益', '予測残在庫数', '予測消化率']
      const suggestCol = ['AIサジェスト後予測販売数', 'AIサジェスト後売上金額', 'AIサジェスト後粗利益', 'AIサジェスト後予測残在庫数', 'AIサジェスト後予測消化率']
      const resultCol = ['売上差額', '粗利差額']
      let title = 'アイテムカテゴリ,品番,商品名,定価,SKUID,販売開始日,当在庫,'

      _.forEach(predictCol, col => title += `${tWeek}${col},`)
      title += '投入週,投入数,'
      _.forEach(predictCol, col => title += `${lWeek}${col},`)
      _.forEach(suggestCol, col => title += `${lWeek}${col},`)
      _.forEach(resultCol, col => title += `${lWeek}${col},`)

      return title.slice(0, -1) + '\n'
    },

    /**
     * item情報を追加発注CSV(SKU)に変換
     */
    orderSkuToCsv_(sku) {
      const list = [
        sku.category_name,
        sku.part_no,
        sku.item_name,
        sku.price,
        sku.sku_id,
        sku.sales_start_date,
        sku.actual_stock,
        sku.target_sale,
        sku.target_amount,
        sku.target_profit,
        sku.target_stock,
        sku.target_consumption,
        sku.order_feed_week,
        sku.order_num,
        sku.last_sale,
        sku.last_amount,
        sku.last_profit,
        sku.last_stock,
        sku.last_consumption,
        sku.order_sale,
        sku.order_amount,
        sku.order_profit,
        sku.order_stock,
        sku.order_consumption,
        sku.last_amount_diff,
        sku.last_profit_diff
      ]
      return list.join(',') + '\n'
    },

    /**
     * 日別予実CSVダウンロード
     * 日別のitem一覧のマークダウン情報を付与したCSVファイルをダウンロードする
     */
    async onPredictLogDownload(suggest_type) {
      let content = await this.getPredictLogDownload({ suggest_type: suggest_type })

      // [Content-Disposition: attachment; filename=xxx.csv] から [xxx.csv]の部分のみを抽出
      const file_name = content.headers['content-disposition'].split('filename=')[1]

      const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      const blob = new Blob([bom, content.data], { "type": "text/csv" })
      this.downloadCsv_(file_name, blob)
    },

    /**
     * ファイルDL
     */
    downloadCsv_(filename, blob) {
      // IE10/IE11
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, filename)

        // firefox, chrome
      } else if (window.URL && window.URL.createObjectURL) {
        const a = document.createElement('a')
        a.href = window.URL.createObjectURL(blob)
        a.download = filename
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
    },

    /**
     * [TSIセール対応]マークダウンCSVダウンロード
     * CSVファイルをダウンロードする
     */
    async onSaleMarkDownload() {
      let content = await this.getSaleMarkDownCSVDownload()

      // [Content-Disposition: attachment; filename=xxx.csv] から [xxx.csv]の部分のみを抽出
      const file_name = content.headers['content-disposition'].split('filename=')[1]

      const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      const blob = new Blob([bom, content.data], { "type": "text/csv" })
      this.downloadCsv_(file_name, blob)
    },

    /**
     * 当週マークダウン対象のみを表示したCSVファイルをダウンロードする
     */
    async onWeeklyMarkDownload() {
      let content = await this.getWeeklyMarkDownCSVDownload()

      // [Content-Disposition: attachment; filename=xxx.csv] から [xxx.csv]の部分のみを抽出
      const file_name = content.headers['content-disposition'].split('filename=')[1]

      const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      const blob = new Blob([bom, content.data], { "type": "text/csv" })
      this.downloadCsv_(file_name, blob)
    },

    deleteSearchWord() {
      //×アイコンにフォーカスが移ってしまうので、テキストフィールドに再フォーカス
      document.getElementsByClassName('item-list__search-box')[0].focus()
      this.itemSearchWord = ''
    }
  },

  mounted() {
    this.scrollItem_()
  }
}



// WEBPACK FOOTER //
// ./src/components/aftersale/predict/itemlist/itemlist.js